export const ellipsis = () => `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
